import React from 'react'

import { useLocation } from 'react-router-dom';
import FireExtiguisherLayout from './FireExtinguisherLayout';

function FeEquipmentView() {
  const location = useLocation();
  const data = location.state?.data;
  
  return (
   <FireExtiguisherLayout
   BackButtonAccess={true} 
   >     <div className="w-full h-full mt-0.5 px-4  ">
   <div className="sm:w-[98%] h-[calc(100vh-195px)]   bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between   z-10">
   
   <div className="w-full bg-white    mt-2 rounded-lg ">
              <div className="w-full py-[1%] bg-baseColor-primary flex justify-between rounded-lg">
              
                <p className="w-[5%]  text-center pl-2 text-white text-xs font-medium">
                  S.No{" "}
                </p>

                <p className=" w-[10%]   text-left text-white text-xs font-medium">
                  {" "}
                  Name{" "}
                </p>
                <p className=" w-[10%] text-center text-white text-xs font-medium">
                  {" "}
                  Brand
                </p>
                   <p className=" w-[10%] text-center  text-white text-xs font-medium">
                  {" "}
                  Model
                </p>
                <p className=" w-[10%] text-center  text-white text-xs font-medium">
                  {" "}
                  Quantity
                </p>
                <p className=" w-[10%] text-center  text-white text-xs font-medium">
                  {" "}
                  Unit
                </p>
              </div>
                {data?.items?.map((List, index) => {
                  return (
                    <div
                      key={index}
                      className="w-full py-2 flex justify-between odd:bg-white even:bg-slate-100"
                    >
                      <p className="w-[5%]  text-center pl-2  text-xs font-medium text-[#111537] py-1">
                        {index + 1}
                      </p>
                     
                      <p className=" w-[10%]   text-left  text-xs font-medium text-[#111537] py-1">
                        {List?.name}
                      </p>
                      <p className=" w-[10%] text-center  text-xs font-medium text-[#111537] py-1">
                        {List?.brand}
                      </p>
                     

                      <p className=" w-[10%] text-center   text-xs font-medium text-[#111537] py-1">
                        {List?.model}
                      </p>
                      <p className=" w-[10%] text-center  text-xs font-medium text-[#111537] py-1">
                        {List?.quantity}
                      </p>
                      <p className=" w-[10%] text-center  text-xs font-medium text-[#111537] py-1">
                        {List?.unit}
                      </p>
                    </div>
                  );
                })}
            </div>

</div>
</div></FireExtiguisherLayout>
  )
}

export default FeEquipmentView